import { render } from "./Verify.vue?vue&type=template&id=6fd3586f"
import script from "./Verify.vue?vue&type=script&lang=js"
export * from "./Verify.vue?vue&type=script&lang=js"
script.render = render

export default script